import React from 'react'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AssignmentIcon from '@mui/icons-material/Assignment'
import useClasses from '../../../hooks/UseClasses'
import { useTranslation } from 'react-i18next'

const styles = (theme) => ({
  link: {
    margin: '1rem auto',
    display: 'block',
    color: theme.palette.text.light.color + ' !important',
    variant: 'h5',
    textDecoration: 'underline !important',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.text.success.color + ' !important',
      textDecoration: 'none !important',
    },
    '& .MuiTypography-root': {
      color: theme.palette.text.light.color,
      '&:hover': {
        color: theme.palette.text.success.color + ' !important',
      },
    },
  },
})

const HeaderConditions = () => {
  const { t } = useTranslation()
  const classes = useClasses(styles)
  return (
    <>
      <IconButton
        className={classes.link}
        onClick={() =>
          window.open(window.location.protocol + '//' + window.location.host + '/assets/termOfUse.pdf', '_blank')
        }
        size="large">
        <AssignmentIcon style={{ marginRight: '4px' }} fontSize={'medium'} />
        <Typography>{t('HEADER.CONDITIONS')}</Typography>
      </IconButton>
    </>
  )
}

export default HeaderConditions
